dmx.Actions({

    'toast.setup': function(options) {
        dmx.bs5toast.setup(this.parse(options));
    },

    'toast.show': function(options) {
        dmx.bs5toast.show(this.parse(options));
    },

    'toast.clear': function() {
        dmx.bs5toast.clear();
    }

});